export default "/images/89d8631635984741936a81ea2ef8797c.avif";